module.exports = __webpack_public_path__ + "img/ticket.2ecd096a.svg";